//Constants defining payment selector types.
export const PAYMENT_SELECTOR_TYPES = {
  CREDIT: 'credit',
  ECHECK: 'eCheck',
  SEPA: 'sepa',
  PAD: 'pad',
}
//Constants mapping payment types by their IDs.
export const PAYMENT_TYPES_BY_ID = {
  4: 'ECHECK',
  5: 'VISA',
  6: 'MASTERCARD',
  7: 'DISCOVER',
  8: 'AMEX',
  9: 'CHECK_21',
  10: 'MONEYGRAM',
  13: 'SEPA',
  14: 'PAD',
  16: 'INSTANT_BANK_TRANSFER',
  17: 'UNION_PAY',
  20: 'CARD',
  22: 'BACS'
}
//Constants defining payment types.
export const PAYMENT_TYPES = {
  ECHECK: {
    getName: () => __('eCheck'),
    value: 4,
  },
  VISA: {
    getName: () => __('Visa'),
    value: 5,
  },
  MASTERCARD: {
    getName: () => __('Mastercard'),
    value: 6,
  },
  DISCOVER: {
    getName: () => __('Discover'),
    value: 7,
  },
  AMEX: {
    getName: () => __('American Express'),
    value: 8,
  },
  CHECK_21: {
    getName: () => __('Check 21'),
    value: 9,
  },
  MONEYGRAM: {
    getName: () => __('E Money Gram'),
    value: 10,
  },
  SEPA: {
    getName: () => __('SEPA Direct Debit'),
    value: 13,
  },
  PAD: {
    getName: () => __('Pre-Authorized Debit'),
    value: 14,
  },
  INSTANT_BANK_TRANSFER: {
    getName: () => __('Instant Bank Transfer'),
    value: 16,
  },
  UNION_PAY: {
    getName: () => __('China UnionPay'),
    value: 17,
  },
  CARD: {
    getName: () => __('CARD'),
    value: 20,
  },
  BACS: {
    getName: () => __('BACS Direct Debit'),
    value: 22,
  },
  APPLE_PAY: {
    getName: () => __('Apple Pay'),
    value: 55,
  },
  REWARD_POINTS: {
    getName: () => __('Reward Points'),
    value: 24,
  },
  ELECTRONIC_BANK_TRANSFER: {
    getName: () => __('Electronic Bank Transfer'),
    value: 25,
  },
}
//Constants mapping ledger transaction types.
export const LEDGER_TRANSACTION_TYPES = {
  PAYMENT: {
    value: 1,
  },
  CHARGE: {
    value: 2,
  },
  CREDIT: {
    value: 3,
  },
  RETURNED: {
    value: 4,
  },
}

//Constants defining types of autopay.
export const AUTOPAY_TYPES = {
  MONTHLY: 'standard',
  BIMONTHLY: 'bimonthly',
  SPLIT: 'split',
}
//Constants mapping account types by their IDs.
export const ACCOUNT_TYPES_BY_ID = {
  1: 'BUSINESS_CHECKING',
  2: 'BUSINESS_SAVINGS',
  3: 'PERSONAL_CHECKING',
  4: 'PERSONAL_SAVINGS',
  5: 'OWNER_DISTRIBUTION',
  6: 'OWNER_CONTRIBUTION',
}

//Constants defining account types.
export const ACCOUNT_TYPES = {
  BUSINESS_CHECKING: {
    getName: () => __('Business Checking'),
    value: 1,
  },
  BUSINESS_SAVINGS: {
    getName: () => __('Business Savings'),
    value: 2,
  },
  PERSONAL_CHECKING: {
    getName: () => __('Checking Acct'),
    value: 3,
  },
  PERSONAL_SAVINGS: {
    getName: () => __('Savings Acct'),
    value: 4,
  },
  OWNER_DISTRIBUTION: {
    getName: () => '',
    value: 5,
  },
  OWNER_CONTRIBUTION: {
    getName: () => '',
    value: 6,
  },
}

//Array containing payment type IDs for card payments.
export const CARD_PAYMENT_TYPE_IDS = [
  PAYMENT_TYPES.VISA.value,
  PAYMENT_TYPES.MASTERCARD.value,
  PAYMENT_TYPES.DISCOVER.value,
  PAYMENT_TYPES.AMEX.value,
]

//Constants defining options for end date.
export const END_DATE_OPTIONS = {
  CANCEL: __('Until I Cancel'),
  CANCEL_OR_MOVE: __('Until I Cancel or Move Out'),
}

//Constants defining values for end date options for.
export const END_DATE_OPTION_VALUES = {
  CANCEL: 0,
  CANCEL_OR_MOVE: 1,
}

//Constants mapping last day values for.
export const LAST_DAY_VALUE = {
  29: 2, // third-to-last day of month
  30: 1, // second-last day of month
  31: 0, // last-day of month
}

//Constants mapping payment status types by their IDs.
export const PAYMENT_STATUS_TYPES_BY_ID = {
  PENDING: 1,
  RECEIVED: 2,
  AUTHORIZING: 5,
  AUTHORIZED: 6,
  VOIDED: 8,
  CAPTURING: 9,
  PHONE_CAPTURE_PENDING: 20,
  CAPTURED: 10,
  RETURNED: 15,
  DELETED: 19,
  REVERSED: 12,
}

//Constants defining payment types for accounts payable.
export const AP_PAYMENT_TYPES = {
  ECHECK: {
    getName: () => __('eCheck'),
    value: 5,
  },
  FAST_FUNDS: {
    getName: () => __('Fast Funds'),
    value: 14,
  },
}

//Constants defining payment split types.
export const PAYMENT_SPLIT_TYPE = {
  PERCENT: 'percent',
  AMOUNT: 'amount',
}

//Constants mapping gateway types with their names and values.
export const GATEWAY_TYPES = {
  'STRIPE': {
    getName: () => __('Stripe'),
    value: 'stripe',
  },
  'WORLDPAY': {
    getName: () => __('WorldPay'),
    value: 'worldpay',
  }
}

//Array containing payment type IDs for OFAC.
export const OFAC_PAYMENT_TYPE_IDS = [
  PAYMENT_TYPES.ECHECK.value,
  PAYMENT_TYPES.PAD.value,
  PAYMENT_TYPES.VISA.value,
  PAYMENT_TYPES.MASTERCARD.value,
  PAYMENT_TYPES.DISCOVER.value,
  PAYMENT_TYPES.AMEX.value,
]

// Define type for Apple Pay Cards
export const APPLE_PAY_CARD_TYPE = {
  CREDIT: 'credit',
  DEBIT: 'debit'
}

// Define button types for Apple Pay Button
export const APPLE_PAY_BUTTON_TYPE = {
  PLAIN: 'plain',
  CONTINUE: 'continue'
}

export const OTHER_PAYMENT_TYPES = ['JCB', 'UnionPay']

export const TRANSFERMATE_TEXT = 'transfermate'

export const HB_EXCLUDED_PAYMENT_TYPES = [
  PAYMENT_TYPES.MONEYGRAM.value
];

// Array containing payment type IDs for Canada default payment types support.
export const DEFAULT_CA_PAYMENT_TYPE_IDS = [
  PAYMENT_TYPES.PAD.value,
  PAYMENT_TYPES.VISA.value,
  PAYMENT_TYPES.MASTERCARD.value,
  PAYMENT_TYPES.DISCOVER.value,
  PAYMENT_TYPES.AMEX.value,
]

export const APPLE_PAY_WALLET_PROVIDER_ID = 1